import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

import useSwitchChild from '@/hooks/useSwitchChild';

/**
 * Header control to switch the active child. Uses the shared switchChild handler.
 */
export default function ChildSelector() {
	const { switchChild, switchingLocked, selectedCustomerId, children } = useSwitchChild();

	if (!children.length) return null;

	if (children.length === 1) {
		const only = children[0];
		const label = only.member?.name || `Child #${only.id}`;
		return (
			<p className='text-xs' data-testid='child-selector-single'>
				Ordering for <span className='font-bold'>{label}</span>
			</p>
		);
	}

	const value = selectedCustomerId != null ? String(selectedCustomerId) : '';

	return (
		<FormControl size='small' fullWidth sx={{ mt: 0.5 }}>
			<InputLabel id='child-selector-label'>Active child</InputLabel>
			<Select
				labelId='child-selector-label'
				id='child-selector'
				label='Active child'
				value={value}
				disabled={switchingLocked}
				onChange={(event) => {
					switchChild(event.target.value);
				}}
				inputProps={{ 'aria-label': 'Active child' }}
			>
				{children.map((child) => (
					<MenuItem key={child.id} value={String(child.id)}>
						{child.member?.name || `Child #${child.id}`}
					</MenuItem>
				))}
			</Select>
		</FormControl>
	);
}
